"use client";

import { useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseUsCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const buttonRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const button = buttonRef.current;
    if (!button) return;
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mediaQuery.matches) return;
    let animationFrameId: number;
    let startTime: number | null = null;
    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const cycle = 8000;
      const progress = elapsed % cycle / cycle;
      let scale = 1;
      if (progress < 0.1) {
        scale = 1 + progress / 0.1 * 0.03;
      } else if (progress < 0.2) {
        scale = 1.03 - (progress - 0.1) / 0.1 * 0.03;
      }
      if (button) {
        button.style.transform = `scale(${scale})`;
      }
      animationFrameId = requestAnimationFrame(animate);
    };
    animationFrameId = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  return <section ref={ref} className="relative py-20 md:py-28 bg-dark-background text-foreground-dark overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }} />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className={`text-3xl sm:text-4xl md:text-5xl font-display font-bold mb-6 leading-tight ${isVisible ? "animate-fade-in-up" : "opacity-0"}`}>
          Why Choose Education Family Tutors?
        </h2>

        <p className={`text-lg sm:text-xl text-foreground-dark/90 mb-10 max-w-2xl mx-auto ${isVisible ? "animate-fade-in-up-delay-100" : "opacity-0"}`}>
          We combine expert academic tutoring with confidence coaching to help
          students learn, thrive, and excel. Our personalised approach builds
          both grades and self-belief.
        </p>

        <div ref={buttonRef} className={`inline-block ${isVisible ? "animate-fade-in-up-delay-200" : "opacity-0"}`} style={{
        willChange: "transform"
      }}>
          <Link to="/ServicesPage">
            <Button size="lg" className="bg-secondary text-foreground-secondary hover:bg-secondary-hover hover:shadow-strong hover:-translate-y-0.5 active:bg-secondary-active active:translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-8 py-4 text-base sm:text-lg font-semibold rounded-md shadow-medium">
              Explore Our Services
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}